import { UpdateFleetPositionsRequest } from '@src/main/modules/parameters/infrastructure/dto/updateFleetPositionsRequest';
import { createFleetHttpRepository } from '@src/main/modules/parameters/infrastructure/repository/FleetHttpRepository';
import { TokenProvider } from '@src/main/shared/infrastructure/entity/axios';

export const updateFleetPositionsUseCase = async (
  id: string,
  data: UpdateFleetPositionsRequest,
  tokenProvider: TokenProvider,
) => {
  const repository = createFleetHttpRepository(tokenProvider);
  return await repository.updatePositions(id, data);
};
